"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startTimer = exports.clearTimer = void 0;

var _loglevel = _interopRequireDefault(require("loglevel"));

var _api = _interopRequireDefault(require("../../api/services/api"));

var MODULE_NAME = 'sdk/token/utils/timer';

var logger = _loglevel.default.getLogger(MODULE_NAME);

var timer = null;

var clearTimer = function clearTimer() {
  logger.info("".concat(MODULE_NAME, " - clearTimer called"), timer);

  if (timer) {
    clearTimeout(timer);
  }
};

exports.clearTimer = clearTimer;

var startTimer = function startTimer(token, timeOut) {
  logger.info("".concat(MODULE_NAME, " - startTimer called"), timeOut);
  timer = setTimeout(function () {
    logger.info("".concat(MODULE_NAME, " - timerUtil tick"), token);

    _api.default.refreshToken(token);
  }, timeOut - 30 * 60 * 1000);
};

exports.startTimer = startTimer;